<script setup>
import ReplenComp from '@/components/ReplenComp.vue'
</script>
<template>
  <main>
    <div class="replen">
      <!-- <ReturnCSV /> -->
      <h1>Weekly BXZ Replen</h1>
      <p>Upload product file, then upload Boxzooka's report file. <br> The items will load in and you can start adding to your cart. Copy your cart once done, then paste into Meg's spreadsheet</p>
      <ReplenComp />
    </div>
  </main>
</template>

<style lang="scss">
.replen {
  text-align: center;
}
</style>
